export default __webpack_public_path__ + "static/media/background.38cf4d6e.svg";